//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import P2PArbitratorsList from '~/views/P2PArbitrators/P2PArbitratorsList/P2PArbitratorsList.vue';

export default {
  components: {
    P2PArbitratorsList,
  },

  async mounted() {
    this.setGeneralLoader(true);
    await Promise.allSettled([
      this.loadP2pArbitratorsList(),
    ]);
    this.setGeneralLoader(false);
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader']),
    ...mapActions('p2pArbitratorsList', {
      loadP2pArbitratorsList: 'loadData',
    }),
  },
};
